import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BaseFormComponent } from '../../base-form.component';
import { CommonFunctions } from 'src/app/shared/common/common-functions';


@Component({
  selector: 'app-boolean-field-v2[formGroup][propertyName]',
  templateUrl: './boolean-field-v2.component.html',
  styles: [],
  standalone: false,
})
export class BooleanFieldV2Component extends BaseFormComponent { 
  @Input() subText?: string;
  @Input() values? = ['Y', 'N'];
  @Input() display? = ['Yes', 'No'];
  @Input() FIELD_SPACING: number;
  @Input() isInnerHTML?: string;
  @Output() userInput? = new EventEmitter<string>();

  constructor(private commonFunctions: CommonFunctions) {
    super(commonFunctions);
  }

  userAction(input: string) {   
    try {         
      if (this.formGroup.get(this.propertyName) != undefined) {
        this.formGroup.get(this.propertyName).setValue(input); 
        this.userInput.emit(input);       
      }   
    } catch(ex) {
      console.log('[BooleanFieldV2Component] this.propertyName='+ this.propertyName +' userAction ex' + ex.message);
    } 
  } 
}
